import React from 'react';

import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import ReactTooltip from 'react-tooltip';

import { UITooltip } from '@shared/ui';

import cls from './AuthorBadge.module.css';

interface AuthorBadgeProps {
    classes?: string;
    type?: 'subcontractor' | 'customer' | 'employee';
    id: string | number;
}

export const AuthorBadge = ({ classes, type, id }: AuthorBadgeProps) => {
    const { t } = useTranslation();

    const labelMapping = {
        subcontractor: t('FilterByAuthor.AuthorBadge.labelMapping.subcontractor'),
        customer: '',
        employee: '',
    };

    if (type !== 'subcontractor') {
        return null;
    }

    return (
        <div className={cn(cls.AuthorBadge, [classes], cls[type])}>
            <UITooltip label={t(`FilterByAuthor.AuthorBadge.labelMapping.${type}.tooltip`)}>
                <span>{labelMapping[type]}</span>
            </UITooltip>
        </div>
    );
};
